import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger);

function scrollTitle(){
	const titles = document.querySelectorAll( '[data-js="scroll-title"]' )

	if ( titles.length > 0 ){
		titles.forEach(title => {
			gsap.to( title, {
				scrollTrigger: {
					trigger: title,
					scrub: 0.9,
					start: 'top center+=150px',
					end: 'bottom top+=100px',
					//markers: true,
				},
				x: `-${ title.scrollWidth - ( window.innerWidth * 0.9 ) }px`,
				ease: 'none'
			});
		});
	}


	/** Titles that are on the banner (and it already passed the "center") */
	const bannerTitles = document.querySelectorAll( '[data-js="scroll-title-banner"]' )

	if ( bannerTitles.length > 0 && window.innerWidth > 827 ){
		bannerTitles.forEach(title => {
			var elDistanceToTop = window.pageYOffset + title.getBoundingClientRect().top
	
			gsap.to( title, {
				scrollTrigger: {
					trigger: title,
					scrub: 0.9,
					start: `top ${elDistanceToTop} + 1`,
					end: 'bottom 100px',
				},
				x: `-${ title.scrollWidth - ( window.innerWidth * 0.65 ) }px`,
				ease: 'none'
			});
		});
	} else {
		bannerTitles.forEach(title => {
			title.classList.remove('whitespace-nowrap')
		})
	}

}


function loadingScreen(){
	const loadingScreen = document.querySelector( '.loading-screen' )
	const loadingBarTop = document.querySelector( '.loading-screen .loading-bar--top' )

	if ( loadingScreen ){
		function endLoadingScreen(){
			loadingScreen.parentNode.removeChild(loadingScreen);
		}

		let loading = gsap.timeline( { onComplete: ()=> endLoadingScreen() } )

		loading
			.to( loadingBarTop, { width: '100%', duration: 1.2, ease: 'none' } )
			.to( loadingScreen, { clipPath: 'inset( 100% 0% 0% 0% )', duration: 1.2, ease: "power3.out" } )
	}
}

export { scrollTitle, loadingScreen };
